module.exports = __webpack_public_path__ + "media/images/element/cart-d0699a3554548456ce3524c6d91f79fa.svg";